import type { EventReminderInput } from './event';

/** Ki írhat az üzenőfalra (a backend BoardPostingPolicy enum sorszámai). */
export enum BoardPostingPolicy {
  AdminsOnly = 0,
  AdminsAndCoaches = 1,
  Everyone = 2,
}

/** Ki szólhat hozzá az üzenőfal bejegyzésekhez (a backend BoardCommentPolicy enum sorszámai). */
export enum BoardCommentPolicy {
  Nobody = 0,
  StaffOnly = 1,
  Everyone = 2,
}

export interface ClubSettings {
  id: number;
  clubName: string | null;
  primaryColor: string;
  crestUrl: string | null;
  updatedAt: string;
  updatedByUserName: string | null;
  /** Új eseményekhez alapból beállított emlékeztetők. */
  defaultEventReminders: EventReminderInput[];
  /** Új esemény létrehozásakor alapból menjen-e azonnali értesítés. */
  notifyOnEventCreateByDefault: boolean;
  /** A rendszerhez kötött MLSZ IFA egyesület azonosítója. */
  mlszClubId: string | null;
  /** A rendszerhez kötött MLSZ IFA egyesület neve. */
  mlszClubName: string | null;
  /** Szedi-e a klub a tagdíjat. Ha nem, a funkció sehol nem jelenik meg. */
  membershipFeesEnabled: boolean;
  /** Hány nappal a lejárat előtt jelezzen a rendszer a sportorvosiról. */
  sportDoctorWarningDays: number;
  /** Vendég felvehet-e saját pályafoglalást (jóváhagyásra várva). */
  guestEventCreationEnabled: boolean;
  /** Ki írhat az üzenőfalra. */
  boardPostingPolicy: BoardPostingPolicy;
  /** Ki szólhat hozzá az üzenőfal bejegyzésekhez. */
  boardCommentPolicy: BoardCommentPolicy;
  /** Edzés után kérdezzük-e a játékosokat, milyen volt. */
  trainingFeedbackEnabled: boolean;
  /** Elérhető-e a nyilvános jelentkezési űrlap. */
  applicationsEnabled: boolean;
  /** Bevezető szöveg a jelentkezési űrlap tetején. */
  applicationIntro: string | null;
  /** Elfogadandó feltételek / adatkezelési tájékoztató. */
  applicationTerms: string | null;
}

export interface UpdateClubSettingsRequest {
  clubName: string | null;
  primaryColor: string;
  /** Ha nincs megadva, az alapértelmezett emlékeztetők változatlanok maradnak. */
  defaultEventReminders?: EventReminderInput[];
  notifyOnEventCreateByDefault?: boolean;
  membershipFeesEnabled?: boolean;
  sportDoctorWarningDays?: number;
  guestEventCreationEnabled?: boolean;
  boardPostingPolicy?: BoardPostingPolicy;
  boardCommentPolicy?: BoardCommentPolicy;
  trainingFeedbackEnabled?: boolean;
  applicationsEnabled?: boolean;
  /** Üres szöveg = törlés, undefined = változatlan. */
  applicationIntro?: string;
  applicationTerms?: string;
}
